/* 中文词典：credit 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const credit = {
  'credit.section.libraries': [ '库' ],
  'credit.section.borrowed': [ '借用的代码与素材' ],
  'credit.note': [ '许可原文与更完整的出处保存在对应源码文件的头部注释里。' ],
  'credit.what.pixi': [ 'WebGL 2D 渲染引擎' ],
  'credit.what.trystero': [ 'WebRTC P2P 库' ],
  'credit.what.trysteroWsRelay': [ 'Trystero 的 WebSocket 中继' ],
  'credit.what.tone': [ 'Web Audio 调度与合成库' ],
  'credit.what.immer': [ '不可变工具库' ],
  'credit.what.zod': [ '运行时数据校验库' ],
  'credit.what.tsAsciiEngine': [ 'ASCII 终端渲染引擎' ],
  'credit.what.alexharri': [ '游戏背景实现使用的着色器' ],
  'credit.what.webglNoise': [ '游戏背景实现使用的单纯形噪声' ],
  'credit.what.glitch': [ '故障滤镜/特效着色器参考（未包含作品源码）' ],
  'credit.what.zenith': [ 'Zenith Tower - TETR.IO Original Soundtrack（游戏背景音乐，未授权借用，侵删）' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
credit satisfies Record<string, TextSpec>;
export default credit;
